export default class HeroContactTabs {
  constructor() {
    this.label = $('.hero-contact-tab label, .hero-contact-tab .btn-close');
  }

  init() {
    this.label.on('click', () => {
      this.onLabelClick();
    });
  }

  onLabelClick() {
    this.label.parent().toggleClass('show-form');
    $('body').toggleClass('hero-contact-tab-open');
  }
}
